module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Foamcore.252a2884.jpg";